import '.cv{display:inline-flex;}.ssr-plugin'
import '.e1{gap:0.44rem;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.dk{text-align:center;}.ssr-plugin'
import '.bq{padding-inline:1rem;}.ssr-plugin'
import '.e2{border-radius:2rem;}.ssr-plugin'
import '.e3{backdrop-filter:blur(2px);}.ssr-plugin'
import '.e4{user-select:none;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { Text } from '../typography/Text.js'
import { ReactNode } from 'react'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type TagProps = {
  variant: Variant
  size?: Size
  label: string
  iconLeft?: IconDefinition
  iconRight?: IconDefinition
  style?: Style
  onClick?: () => void
}

export type Variant =
  | 'transparent'
  | 'tertiary'
  | 'accent'
  | 'primary'
  | 'subtle'
  | 'success'
  | 'neutral'
type Size = 'large' | 'small'

const variantStyle: Record<Variant, Style> = {
  transparent: {
    background: 'transparent',
    color: 'var(--brand-secondary)',
    border: '1px solid var(--brand-secondary)',
  },
  tertiary: {
    background: 'var(--brand-tertiary)',
    color: 'var(--brand-tertiary-foreground)',
    border: '1px solid var(--brand-tertiary)',
  },
  accent: {
    background: 'var(--brand-accent)',
    color: 'var(--brand-secondary)',
    border: '1px solid var(--brand-accent)',
  },
  primary: {
    background: 'var(--brand-primary)',
    color: 'var(--palette-white)',
    border: '1px solid var(--brand-primary)',
  },
  subtle: {
    background: 'var(--palette-blue-50)',
    color: 'var(--brand-secondary)',
    border: 'var(--border-subtle)',
  },
  success: {
    background: 'var(--status-success)',
    color: 'var(--brand-secondary)',
    border: '1px solid var(--status-success)',
  },
  neutral: {
    background: 'var(--palette-steady-stone)',
    color: 'var(--brand-secondary)',
    border: '1px solid var(--palette-steady-stone)',
  },
}

const sizeStyle: Record<Size, Style> = {
  large: {
    paddingBlock: '0.5rem',
  },
  small: {
    paddingBlock: '0.25rem',
  },
}

const iconVariantStyle: Record<Variant, Style> = {
  transparent: {
    color: 'var(--brand-secondary)',
  },
  tertiary: {
    color: 'var(--brand-tertiary-foreground)',
  },
  accent: {
    color: 'var(--brand-secondary)',
  },
  primary: {
    color: 'var(--palette-white)',
  },
  subtle: {
    color: 'var(--brand-secondary)',
  },
  success: {
    color: 'var(--brand-secondary)',
  },
  neutral: {
    color: 'var(--brand-secondary)',
  },
}

const iconSizeStyle: Record<Size, Style> = {
  large: {
    width: '0.9375rem',
    height: '0.9375rem',
  },
  small: {
    width: '0.75rem',
    height: '0.75rem',
  },
}

const sizeRender: Record<Size, (style: Style, label: string) => ReactNode> = {
  large: (style, label) => <Text.Medium style={style}>{label}</Text.Medium>,
  small: (style, label) => <Text.Small style={style}>{label}</Text.Small>,
}

export const Tag = ({
  variant,
  size = 'large',
  label,
  iconLeft,
  iconRight,
  style,
  onClick,
}: TagProps) => {
  return (
    <styled.div className="cv e1 ab r dk bq e2 e3 e4"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        ...sizeStyle[size],
        ...variantStyle[variant],
        ...style,
      }}
    >
      {iconLeft && (
        <FontAwesomeIcon
          key="icon"
          icon={iconLeft}
          style={{ ...iconSizeStyle[size], ...iconVariantStyle[variant] }}
        />
      )}
      {sizeRender[size]({ color: variantStyle[variant].color }, label)}
      {iconRight && (
        <FontAwesomeIcon
          key="icon"
          icon={iconRight}
          style={{ ...iconSizeStyle[size], ...iconVariantStyle[variant] }}
        />
      )}
    </styled.div>
  )
}
